import React from 'react';
import CancelIcon from "../../../../assets/cancel-01-stroke-rounded 1.svg";

interface SelectedTopic {
  id: number;
  name: string;
}

interface SelectedTopicsDisplayProps {
  selectedItems: SelectedTopic[];
  onRemoveTopic: (topic: SelectedTopic) => void;
}

const SelectedTopicsDisplay: React.FC<SelectedTopicsDisplayProps> = ({
  selectedItems,
  onRemoveTopic
}) => {
  if (selectedItems.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="flex flex-wrap gap-1">
        {selectedItems.map((item) => (
          <div
            key={item.id}
            className="inline-flex items-center gap-2 text-gray-700 px-3 py-1 border border-[#D0D5DD] bg-[#FAFAFA] rounded-full shadow-sm"
            style={{
              borderRadius: '999px',
              border: '1px solid #D0D5DD',
              background: 'var(--neutral-50, #FAFAFA)',
              boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)'
            }}
          >
            <button
              onClick={() => onRemoveTopic(item)}
              className="text-gray-500 hover:text-gray-700 transition-colors"
              aria-label={`Remove ${item.name}`}
            >
              <img src={CancelIcon} alt={`Remove ${item.name}`} />
            </button>
            <span className="text-sm">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedTopicsDisplay;
